module.exports = "/_next/static/images/e64660e2d0da09accd0ed2e7b7c397c8-slide-1-small.png";